module.exports = {
  wbt_is_processing: 'This file is currently processing, please check back later.',
  wbt: {
    no_results: 'No entries available',
    table: {
      date: 'Date',
      status: 'Status',
      result: 'Result',
    },
    status: {
      passed: 'Passed',
      failed: 'Not passed',
      completed: 'Complete',
    },
  },
  types: {
    wbt: 'WBT',
    video: 'Video',
    audio: 'Audio',
    document: 'Document',
    document_word: 'Word document',
    document_image: 'Image',
    document_pdf: 'PDF',
    document_powerpoint: 'PowerPoint',
    document_sheet: 'Excel',
    link: 'Link',
    no_attachment: 'Text only',
  },
  audio: {
    play: 'Play audio',
    pause: 'Pause audio',
  },
  startButtonLabel: {
    wbt: 'Start WBT',
    video: 'Start video',
    audio: 'Start audio',
    document: 'Download document',
    document_word: 'Download document',
    document_image: 'Open image',
    document_pdf: 'Open PDF',
    document_powerpoint: 'Download PowerPoint',
    link: 'Open link',
    open_office: 'Open document',
    download_file: 'Download %{title}',
    open_pdf: 'Open PDF %{title}',
  },
  filterLabel: {
    wbt: 'Web Based Training',
    video: 'Video',
    audio: 'Audio',
    document: 'Documents',
    document_word: '.docx (Word)',
    document_image: '.jpeg .png .gif (image)',
    document_pdf: '.pdf',
    document_powerpoint: '.pptx (PowerPoint)',
    document_sheet: '.xls (Excel)',
    no_attachment: 'Text only',
  },
  sortLabels: {
    name_asc: 'Alphabetically (A-Z)',
    name_desc: 'Alphabetically (Z-A)',
    published_at_desc: 'Date (newest first)',
    published_at_asc: 'Date (oldest first)',
  },
  sortShortLabels: {
    name_asc: 'A-Z',
    name_desc: 'Z-A',
    published_at_desc: 'Newest',
    published_at_asc: 'Oldest',
  },
  latest: 'Latest',
  last_viewed: 'Last accessed',
  passed: 'Passed',
  with_percentage: 'with %{score}%',
  search_learningmaterials: 'Find files',
  go_to_learningmaterials: 'Open file',
  latest_learningmaterials: 'Newest files',
  materialcount: '1 file | %{n} files',
  all_categories: 'All folders A-Z',
  new: 'New',
  subfolder: 'Subfolder',
  files: 'Files',
  no_wbt_on_ios: 'Unfortunately, it is currently not possible to play WBTs in the Store app on iOS. Please view the content in your browser.',
  open_wbt_in_browser: 'Open WBT in the browser',
}
